import React from 'react';
import {inject, observer} from 'mobx-react';

import './style/';
import E9Header from './E9Header';
import E9LeftMenu from './E9LeftMenu';

@inject('portalThemeStore')
@observer
class E9ThemeLayout4 extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const {portalThemeStore, location} = this.props;
        const {pathname, query} = location;
        portalThemeStore.getTopMenu(pathname, query);
    }

    render() {
        const {portalThemeStore, location} = this.props;
        const {searchParams, themeInfo} = portalThemeStore;
        const {themeColorType} = themeInfo;
        const colorClassName = themeColorType ? `e9theme-color-${themeColorType}` : '';
        const {query} = location;
        const {hideHeader = query.hideHeader, hideAside = query.hideAside} = searchParams;

        return (
            <div className={`e9theme-layout4-container ${colorClassName}`}>
                {
                    hideHeader == 'true' ? null : (
                        <div className="e9theme-layout4-header">
                            <E9Header {...this.props} />
                        </div>
                    )
                }
                <div className="e9theme-layout4-content" style={hideHeader == 'true' ? {top: 0} : {}}>
                    <div id="themeLayoutMask" className="e9theme-layout4-mask"></div>
                    {
                        hideAside == 'true' ? null : (
                            <div className="e9theme-layout4-aside">
                                <E9LeftMenu {...this.props} />
                            </div>
                        )
                    }
                    <div className="e9theme-layout4-main" style={hideHeader == 'true' && hideAside == 'true' ? {padding: 0} : {}}>
                        <div id="themeLayoutRoute" className="e9theme-layout4-route">
                            {this.props.children}
                        </div>
                        <div id="themeLayoutFrame" className="e9theme-layout4-frame">
                            <iframe id="mainFrame" name="mainFrame" src="about:blank"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default E9ThemeLayout4;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology9/layout4/index.js